import { render } from "./EditPanel.vue?vue&type=template&id=bc86ac5e"
import script from "./EditPanel.vue?vue&type=script&lang=js"
export * from "./EditPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__